<div class="menuAccordian">
  <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
    <mat-expansion-panel
      *ngFor="let process of processTypeList; let i = index"
      [expanded]="process.processName === this.processStage"
      id="processHeaderId{{ i }}"
    >
      <mat-expansion-panel-header name="processName">
        <mat-panel-title id="{{ process.processName }}">
          {{ process.processName }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="listItemSingle">
        <li *ngFor="let activity of process.activityprocess; let j = index">
          <button
            mat-flat-button
            class="text-btn"
            name="activitybtn{{ i }}"
            id="pr{{ activity.activityDescription }}"
            name="activitybtn{{ i }}"
            [disabled]="activity.write === 'false'"
            (click)="subActivity(process.processId, activity)"
          >
            {{ activity.activityDescription }}
          </button>
        </li>
      </ul>
    </mat-expansion-panel>

    <!-- a          -->
  </mat-accordion>
</div>
